import { render, staticRenderFns } from "./editorjs.vue?vue&type=template&id=06101d3d"
import script from "./editorjs.vue?vue&type=script&lang=js"
export * from "./editorjs.vue?vue&type=script&lang=js"
import style0 from "./editorjs.vue?vue&type=style&index=0&id=06101d3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports